// React
import React, { useState } from "react";

// Interfaces and types
import { HeroProps } from "./interface";

// Styles
import "./hero.scss";

// Assets
import portrait from "./../../assets/img/portrait.jpg";
import { EmailButton } from "../EmailButton/EmailButton";

const Hero = ({
  givenName,
  familyName,
  email,
  role,
  portraitUrl,
}: HeroProps) => {
  const [animateGreeting, setAnimateGreeting] = useState<boolean>(false);

  const fullName = givenName + " " + familyName

  const portraitAlt: string = `Photo of ${fullName}`;

  // Welcome message and classes that animate it
  const messageClass: string =
    "hero__welcome" + (animateGreeting ? " hero__pop" : "");
  const waveClass: string = animateGreeting ? "hero__wave" : "";

  const welcomeMessage: JSX.Element = (
    <span className={messageClass}>
      Hey there! <span className={waveClass}>👋</span>
    </span>
  );

  return (
    <>
      <section className="hero" id="top">
        <div
          className="hero__portrait-container"
          // onMouseEnter={(): void => {
          //   setAnimateGreeting(true);
          // }}
          // onMouseLeave={(): void => {
          //   setAnimateGreeting(false);
          // }}
        >
          <img
            className="hero__portrait portrait--js"
            src={portraitUrl || portrait}
            alt={portraitAlt}
          />
          {/* {welcomeMessage} */}
        </div>
        <div className="hero__text-container">
          <h1 className="hero__header">
            {fullName} –{" "}
            <strong className="hero__header-emphasis">{role}</strong>
          </h1>
          <section className="hero__introduction">
            <p>
              Welcome to an old dev page of mine (as they say, if it ain't
              broke, don't fix it).
            </p>
            <p>
              Anyway,{" "}
              <a href="/filip-rybczynski-cv.pdf" className="hero__introduction-link">
                here's my CV.
              </a>
            </p>
            <p>
              You can also check out{" "}
              <a className="hero__introduction-link" href="#skills">
                my skills
              </a>
              . Don’t forget to take a look at{" "}
              <a className="hero__introduction-link" href="#projects">
                my projects
              </a>
              . Always looking for new challenges or opportunities so if you
              have one -{" "}
              <a className="hero__introduction-link" href="#contact">
                contact me!
              </a>
            </p>
          </section>
        </div>
        <EmailButton email={email} />
      </section>
      <a className="top-link" href="#top">
        Back to top
      </a>
    </>
  );
};

export default Hero;
